// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    AdmissionSourceType,
    AdmissionSourceTypeFromJSON,
    AdmissionSourceTypeToJSON,
    AdmissionType,
    AdmissionTypeFromJSON,
    AdmissionTypeToJSON,
    ClassificationCodeType,
    ClassificationCodeTypeFromJSON,
    ClassificationCodeTypeToJSON,
    FacilityCodeType,
    FacilityCodeTypeFromJSON,
    FacilityCodeTypeToJSON,
    FrequencyCodeType,
    FrequencyCodeTypeFromJSON,
    FrequencyCodeTypeToJSON,
    HourType,
    HourTypeFromJSON,
    HourTypeToJSON,
    PatientStatusType,
    PatientStatusTypeFromJSON,
    PatientStatusTypeToJSON,
    ProviderCreateClaimInstitutionalConditionCodes,
    ProviderCreateClaimInstitutionalConditionCodesFromJSON,
    ProviderCreateClaimInstitutionalConditionCodesToJSON,
    ProviderCreateClaimInstitutionalExternalCauseOfInjuryDiagnosisCodes,
    ProviderCreateClaimInstitutionalExternalCauseOfInjuryDiagnosisCodesFromJSON,
    ProviderCreateClaimInstitutionalExternalCauseOfInjuryDiagnosisCodesToJSON,
    ProviderCreateClaimInstitutionalOccurrenceSpan,
    ProviderCreateClaimInstitutionalOccurrenceSpanFromJSON,
    ProviderCreateClaimInstitutionalOccurrenceSpanToJSON,
    ProviderCreateClaimInstitutionalOccurrences,
    ProviderCreateClaimInstitutionalOccurrencesFromJSON,
    ProviderCreateClaimInstitutionalOccurrencesToJSON,
    ProviderCreateClaimInstitutionalOtherDiagnosisCodes,
    ProviderCreateClaimInstitutionalOtherDiagnosisCodesFromJSON,
    ProviderCreateClaimInstitutionalOtherDiagnosisCodesToJSON,
    ProviderCreateClaimInstitutionalOtherProcedureCodes,
    ProviderCreateClaimInstitutionalOtherProcedureCodesFromJSON,
    ProviderCreateClaimInstitutionalOtherProcedureCodesToJSON,
    ProviderCreateClaimInstitutionalPatientReasonForVisitDiagnosisCodes,
    ProviderCreateClaimInstitutionalPatientReasonForVisitDiagnosisCodesFromJSON,
    ProviderCreateClaimInstitutionalPatientReasonForVisitDiagnosisCodesToJSON,
    ProviderCreateClaimInstitutionalServices,
    ProviderCreateClaimInstitutionalServicesFromJSON,
    ProviderCreateClaimInstitutionalServicesToJSON,
    ProviderCreateClaimInstitutionalValueCodes,
    ProviderCreateClaimInstitutionalValueCodesFromJSON,
    ProviderCreateClaimInstitutionalValueCodesToJSON,
    ProviderCreateClaimTypePayload,
    ProviderCreateClaimTypePayloadFromJSON,
    ProviderCreateClaimTypePayloadToJSON,
    StateType,
    StateTypeFromJSON,
    StateTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderCreateClaimInstitutionalPayload
 */
export interface ProviderCreateClaimInstitutionalPayload extends ProviderCreateClaimTypePayload {
    /**
     * 
     * OpenAPI data type: {FacilityCodeType}
     * @type {FacilityCodeType}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    typeOfBill2ndDigitTypeOfFacilityCode: FacilityCodeType;
    /**
     * 
     * OpenAPI data type: {ClassificationCodeType}
     * @type {ClassificationCodeType}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    typeOfBill3rdDigitBillClassificationCode: ClassificationCodeType;
    /**
     * 
     * OpenAPI data type: {FrequencyCodeType}
     * @type {FrequencyCodeType}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    typeOfBill4thDigitFrequencyCode: FrequencyCodeType;
    /**
     * Field 6 statement from date for the service covered on the claim
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    statementFromDate?: string;
    /**
     * Field 6 statement through date for the service covered on the claim
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    statementThroughDate?: string;
    /**
     * Field 12 admission date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    admissionDate?: string;
    /**
     * 
     * OpenAPI data type: {HourType}
     * @type {HourType}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    admissionHour?: HourType;
    /**
     * 
     * OpenAPI data type: {AdmissionType}
     * @type {AdmissionType}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    admissionType?: AdmissionType;
    /**
     * 
     * OpenAPI data type: {AdmissionSourceType}
     * @type {AdmissionSourceType}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    admissionSource?: AdmissionSourceType;
    /**
     * 
     * OpenAPI data type: {HourType}
     * @type {HourType}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    dischargeHour?: HourType;
    /**
     * 
     * OpenAPI data type: {PatientStatusType}
     * @type {PatientStatusType}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    patientStatus?: PatientStatusType;
    /**
     * Field 21 diagnosis code
     * OpenAPI data type: {array}
     * @type {Array<ProviderCreateClaimInstitutionalConditionCodes>}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    conditionCodes?: Array<ProviderCreateClaimInstitutionalConditionCodes>;
    /**
     * 
     * OpenAPI data type: {StateType}
     * @type {StateType}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    accidentState?: StateType;
    /**
     * Field 31+ occurrences
     * OpenAPI data type: {array}
     * @type {Array<ProviderCreateClaimInstitutionalOccurrences>}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    occurrences?: Array<ProviderCreateClaimInstitutionalOccurrences>;
    /**
     * Field 35+ occurrence spans
     * OpenAPI data type: {array}
     * @type {Array<ProviderCreateClaimInstitutionalOccurrenceSpan>}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    occurrenceSpans?: Array<ProviderCreateClaimInstitutionalOccurrenceSpan>;
    /**
     * Field 39+ value codes
     * OpenAPI data type: {array}
     * @type {Array<ProviderCreateClaimInstitutionalValueCodes>}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    valueCodes?: Array<ProviderCreateClaimInstitutionalValueCodes>;
    /**
     * Field 67 principal diagnosis code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    principalDiagnosisCode: string;
    /**
     * Field 67 other diagnosis codes
     * OpenAPI data type: {array}
     * @type {Array<ProviderCreateClaimInstitutionalOtherDiagnosisCodes>}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    otherDiagnosisCodes?: Array<ProviderCreateClaimInstitutionalOtherDiagnosisCodes>;
    /**
     * Field 69 admitting diagnosis code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    admittingDiagnosisCode?: string;
    /**
     * Field 70+ reason for visit diagnosis codes
     * OpenAPI data type: {array}
     * @type {Array<ProviderCreateClaimInstitutionalPatientReasonForVisitDiagnosisCodes>}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    patientReasonForVisitDiagnosisCodes?: Array<ProviderCreateClaimInstitutionalPatientReasonForVisitDiagnosisCodes>;
    /**
     * Field 72 external cause of injury codes
     * OpenAPI data type: {array}
     * @type {Array<ProviderCreateClaimInstitutionalExternalCauseOfInjuryDiagnosisCodes>}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    externalCauseOfInjuryDiagnosisCodes?: Array<ProviderCreateClaimInstitutionalExternalCauseOfInjuryDiagnosisCodes>;
    /**
     * Field 74 principal procedure code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    principalProcedureCode?: string;
    /**
     * Field 74 principal procedure code
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    principalProcedureDate?: string;
    /**
     * Field 74 principal procedure code
     * OpenAPI data type: {array}
     * @type {Array<ProviderCreateClaimInstitutionalOtherProcedureCodes>}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    otherProcedureCodes?: Array<ProviderCreateClaimInstitutionalOtherProcedureCodes>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderCreateClaimInstitutionalServices>}
     * @memberof ProviderCreateClaimInstitutionalPayload
     */
    services: Array<ProviderCreateClaimInstitutionalServices>;
}

export function ProviderCreateClaimInstitutionalPayloadFromJSON(json: any): ProviderCreateClaimInstitutionalPayload {
    return {
                'typeOfBill2ndDigitTypeOfFacilityCode': FacilityCodeTypeFromJSON(json['typeOfBill2ndDigitTypeOfFacilityCode']),
                'typeOfBill3rdDigitBillClassificationCode': ClassificationCodeTypeFromJSON(json['typeOfBill3rdDigitBillClassificationCode']),
                'typeOfBill4thDigitFrequencyCode': FrequencyCodeTypeFromJSON(json['typeOfBill4thDigitFrequencyCode']),
                'statementFromDate': !exists(json, 'statementFromDate') ? undefined : json['statementFromDate'],
                'statementThroughDate': !exists(json, 'statementThroughDate') ? undefined : json['statementThroughDate'],
                'admissionDate': !exists(json, 'admissionDate') ? undefined : json['admissionDate'],
                'admissionHour': !exists(json, 'admissionHour') ? undefined : HourTypeFromJSON(json['admissionHour']),
                'admissionType': !exists(json, 'admissionType') ? undefined : AdmissionTypeFromJSON(json['admissionType']),
                'admissionSource': !exists(json, 'admissionSource') ? undefined : AdmissionSourceTypeFromJSON(json['admissionSource']),
                'dischargeHour': !exists(json, 'dischargeHour') ? undefined : HourTypeFromJSON(json['dischargeHour']),
                'patientStatus': !exists(json, 'patientStatus') ? undefined : PatientStatusTypeFromJSON(json['patientStatus']),
                'conditionCodes': !exists(json, 'conditionCodes') ? undefined : (json['conditionCodes'] as Array<any>).map(ProviderCreateClaimInstitutionalConditionCodesFromJSON),
                'accidentState': !exists(json, 'accidentState') ? undefined : StateTypeFromJSON(json['accidentState']),
                'occurrences': !exists(json, 'occurrences') ? undefined : (json['occurrences'] as Array<any>).map(ProviderCreateClaimInstitutionalOccurrencesFromJSON),
                'occurrenceSpans': !exists(json, 'occurrenceSpans') ? undefined : (json['occurrenceSpans'] as Array<any>).map(ProviderCreateClaimInstitutionalOccurrenceSpanFromJSON),
                'valueCodes': !exists(json, 'valueCodes') ? undefined : (json['valueCodes'] as Array<any>).map(ProviderCreateClaimInstitutionalValueCodesFromJSON),
                'principalDiagnosisCode': json['principalDiagnosisCode'],
                'otherDiagnosisCodes': !exists(json, 'otherDiagnosisCodes') ? undefined : (json['otherDiagnosisCodes'] as Array<any>).map(ProviderCreateClaimInstitutionalOtherDiagnosisCodesFromJSON),
                'admittingDiagnosisCode': !exists(json, 'admittingDiagnosisCode') ? undefined : json['admittingDiagnosisCode'],
                'patientReasonForVisitDiagnosisCodes': !exists(json, 'patientReasonForVisitDiagnosisCodes') ? undefined : (json['patientReasonForVisitDiagnosisCodes'] as Array<any>).map(ProviderCreateClaimInstitutionalPatientReasonForVisitDiagnosisCodesFromJSON),
                'externalCauseOfInjuryDiagnosisCodes': !exists(json, 'externalCauseOfInjuryDiagnosisCodes') ? undefined : (json['externalCauseOfInjuryDiagnosisCodes'] as Array<any>).map(ProviderCreateClaimInstitutionalExternalCauseOfInjuryDiagnosisCodesFromJSON),
                'principalProcedureCode': !exists(json, 'principalProcedureCode') ? undefined : json['principalProcedureCode'],
                'principalProcedureDate': !exists(json, 'principalProcedureDate') ? undefined : json['principalProcedureDate'],
                'otherProcedureCodes': !exists(json, 'otherProcedureCodes') ? undefined : (json['otherProcedureCodes'] as Array<any>).map(ProviderCreateClaimInstitutionalOtherProcedureCodesFromJSON),
                'services': (json['services'] as Array<any>).map(ProviderCreateClaimInstitutionalServicesFromJSON),
        ...ProviderCreateClaimTypePayloadFromJSON(json)
    };

}

export function ProviderCreateClaimInstitutionalPayloadToForm(value?: ProviderCreateClaimInstitutionalPayload): any {
    let jsonVal = ProviderCreateClaimInstitutionalPayloadToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ProviderCreateClaimInstitutionalPayloadToJSON(value?: ProviderCreateClaimInstitutionalPayload): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'typeOfBill2ndDigitTypeOfFacilityCode': FacilityCodeTypeToJSON(value.typeOfBill2ndDigitTypeOfFacilityCode),
            'typeOfBill3rdDigitBillClassificationCode': ClassificationCodeTypeToJSON(value.typeOfBill3rdDigitBillClassificationCode),
            'typeOfBill4thDigitFrequencyCode': FrequencyCodeTypeToJSON(value.typeOfBill4thDigitFrequencyCode),
            'statementFromDate': cleanupBlankValuesForBackend(value.statementFromDate),
            'statementThroughDate': cleanupBlankValuesForBackend(value.statementThroughDate),
            'admissionDate': cleanupBlankValuesForBackend(value.admissionDate),
            'admissionHour': HourTypeToJSON(value.admissionHour),
            'admissionType': AdmissionTypeToJSON(value.admissionType),
            'admissionSource': AdmissionSourceTypeToJSON(value.admissionSource),
            'dischargeHour': HourTypeToJSON(value.dischargeHour),
            'patientStatus': PatientStatusTypeToJSON(value.patientStatus),
            'conditionCodes': (value.conditionCodes === undefined || value.conditionCodes === null) ? undefined  : (value.conditionCodes as Array<any>).map(ProviderCreateClaimInstitutionalConditionCodesToJSON),
            'accidentState': StateTypeToJSON(value.accidentState),
            'occurrences': (value.occurrences === undefined || value.occurrences === null) ? undefined  : (value.occurrences as Array<any>).map(ProviderCreateClaimInstitutionalOccurrencesToJSON),
            'occurrenceSpans': (value.occurrenceSpans === undefined || value.occurrenceSpans === null) ? undefined  : (value.occurrenceSpans as Array<any>).map(ProviderCreateClaimInstitutionalOccurrenceSpanToJSON),
            'valueCodes': (value.valueCodes === undefined || value.valueCodes === null) ? undefined  : (value.valueCodes as Array<any>).map(ProviderCreateClaimInstitutionalValueCodesToJSON),
            'principalDiagnosisCode': cleanupBlankValuesForBackend(value.principalDiagnosisCode),
            'otherDiagnosisCodes': (value.otherDiagnosisCodes === undefined || value.otherDiagnosisCodes === null) ? undefined  : (value.otherDiagnosisCodes as Array<any>).map(ProviderCreateClaimInstitutionalOtherDiagnosisCodesToJSON),
            'admittingDiagnosisCode': cleanupBlankValuesForBackend(value.admittingDiagnosisCode),
            'patientReasonForVisitDiagnosisCodes': (value.patientReasonForVisitDiagnosisCodes === undefined || value.patientReasonForVisitDiagnosisCodes === null) ? undefined  : (value.patientReasonForVisitDiagnosisCodes as Array<any>).map(ProviderCreateClaimInstitutionalPatientReasonForVisitDiagnosisCodesToJSON),
            'externalCauseOfInjuryDiagnosisCodes': (value.externalCauseOfInjuryDiagnosisCodes === undefined || value.externalCauseOfInjuryDiagnosisCodes === null) ? undefined  : (value.externalCauseOfInjuryDiagnosisCodes as Array<any>).map(ProviderCreateClaimInstitutionalExternalCauseOfInjuryDiagnosisCodesToJSON),
            'principalProcedureCode': cleanupBlankValuesForBackend(value.principalProcedureCode),
            'principalProcedureDate': cleanupBlankValuesForBackend(value.principalProcedureDate),
            'otherProcedureCodes': (value.otherProcedureCodes === undefined || value.otherProcedureCodes === null) ? undefined  : (value.otherProcedureCodes as Array<any>).map(ProviderCreateClaimInstitutionalOtherProcedureCodesToJSON),
            'services': (value.services as Array<any>).map(ProviderCreateClaimInstitutionalServicesToJSON),
            ...ProviderCreateClaimTypePayloadToJSON(value)
    };
}


